import { render, staticRenderFns } from "./ProjectInformationForm.vue?vue&type=template&id=bab73f8e"
import script from "./project-information-form.ts?vue&type=script&lang=ts&external"
export * from "./project-information-form.ts?vue&type=script&lang=ts&external"
import style0 from "./project-information-form.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports